/*
  Regalo senza scontrino — Emme4Home
  Salva o toglie l'attributo carrello "Regalo - niente scontrino".
  Non serve rigenerare il carrello: la spunta e gia nello stato giusto.
*/
(function () {
  var CHIAVE = 'Regalo - niente scontrino';

  function cfg(type) {
    if (typeof fetchConfig === 'function') return fetchConfig(type || 'json');
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/' + (type || 'json') }
    };
  }

  class RegaloNoScontrino extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onChange.bind(this));
    }

    onChange(event) {
      const box = event.target;
      if (!box.classList.contains('rns__toggle')) return;

      // Nella pagina carrello la spunta sta dentro <cart-items>, che tratta
      // ogni change come un cambio di quantita: qui ci fermiamo noi.
      event.stopPropagation();

      const self = this;
      const attributes = {};
      attributes[CHIAVE] = box.checked ? 'Sì' : '';
      this.classList.add('cgr--busy');
      this.querySelector('.cgr__error').hidden = true;

      // Allinea l'eventuale seconda spunta in pagina (carrello + drawer)
      document.querySelectorAll('.rns__toggle').forEach(function (el) { el.checked = box.checked; });

      fetch(routes.cart_update_url, Object.assign({}, cfg(), { body: JSON.stringify({ attributes: attributes }) }))
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (state.status) throw new Error(state.description || state.message);
          self.classList.remove('cgr--busy');
        })
        .catch(function (e) {
          self.classList.remove('cgr--busy');
          box.checked = !box.checked;
          const err = self.querySelector('.cgr__error');
          err.textContent = 'Non riesco a salvare la scelta. Riprova tra un attimo.';
          err.hidden = false;
          console.error('[regalo-no-scontrino]', e);
        });
    }
  }

  if (!customElements.get('regalo-no-scontrino')) customElements.define('regalo-no-scontrino', RegaloNoScontrino);
})();
